import { forwardRef } from 'react';

import './Button.scss';
import { useFlag } from '../../services/launchDarkly';

import BlackButton from './BlackButton';
import type { IBlackButtonProps, IButtonProps } from './buttonTypes';
import { OldButton } from './OldButton';
import { StyledButton } from './StyledButton';

const Button = forwardRef<HTMLButtonElement, IButtonProps>(({ coreType, ...props }, forwardedRef) => {
  const newDesignButtons = useFlag('ui_redesign_buttons', true);

  if (newDesignButtons) {
    return <StyledButton {...props} ref={forwardedRef} />;
  }

  if (coreType === 'black') {
    return <BlackButton {...(props as IBlackButtonProps)} />;
  }

  return <OldButton {...props} ref={forwardedRef} />;
});

Button.displayName = 'Button';

export default Button;
